import React from "react";
import { useLocation } from "react-router-dom";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'query-string'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/query-string/index.js' implicitly has an 'any' type.
import queryString from "query-string";
const useParams = () => {
    const { search } = useLocation();
    return React.useMemo(() => queryString.parse(search), [search]);
};
export default useParams;
